(function ($) {
    $(document).ready(function () {
        var buttonScrollTop = $(".scrollup-default");

        $(window).scroll(function () {
            if ($(this).scrollTop() > 300) {
                buttonScrollTop.fadeIn();
            } else {
                buttonScrollTop.fadeOut();
            }
        });

        buttonScrollTop.click(function () {
            $("body, html").animate(
                {
                    scrollTop: 0,
                },
                800
            );

            return false;
        });
    });
})(jQuery);
